// Miky Motorsport - menu + garaz + kariera UI (M3/M4)
import { UPGRADES, upgradeCost, computePI, piClass, carStats, fullUpgradeCost } from './garage.js';
import { levelFromXp, rankName, assistsOffCount } from './economy.js';
import { careerView, medalTally, nextRecommendedEvent, championshipStandings, championshipProgress, medalSlots, goldCollection } from './career.js';
import { DIFFICULTY, findEvent } from './data/events.js';
import { CARS, CAR_ORDER, getCar } from './data/cars.js';
import { TRACKS, TRACK_ORDER, refLapOf } from './data/tracks.js';
import { targetTimes, timeMedalFor, timeMedalTally, medalIcon, medalPrefix, fmtMs } from './timeMedals.js';
import { dailyChallenge, dateKey, effectiveStreak, bestLapMsForTrack } from './daily.js';

const PAINTS = [0xff5e3a, 0x2e6cff, 0x2ecc71, 0xf1c40f, 0x9b59b6, 0xe74c3c, 0x1abc9c, 0xecf0f1, 0x34495e, 0xff8fab];

function div(cls) { const d = document.createElement('div'); d.className = cls; return d; }
function hex(c) { return '#' + (c >>> 0).toString(16).padStart(6, '0').slice(-6); }

// Escapuje dynamicka data (z profilu/localStorage) pred vlozenim do innerHTML.
// Bezna jmena z AI_DEFS jsou bezpecna, ale rucne upraveny/poskozeny profil by mohl
// nest markup ve jmene ridice - tomu zabranime escapovanim (F-104).
export function escapeHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export class MenuGarageUI {
  constructor(callbacks) {
    this.cb = callbacks;
    this.root = document.getElementById('ui');
    this.root.innerHTML = '';

    this.menu = div('screen menu-screen');
    this.menu.innerHTML = `
      <img class="menu-miky" src="./img/miky-avatar.jpg" alt="Miky" draggable="false">
      <div class="menu-title">MIKY <span>MOTORSPORT</span></div>
      <div class="menu-collection" id="menu-collection"></div>
      <button class="btn btn-primary menu-play" data-act="career">KARIÉRA 🏆</button>
      <button class="btn menu-play" data-act="garage">GARÁŽ &amp; RYCHLÝ ZÁVOD</button>
      <button class="btn menu-play" data-act="tt">TIME TRIAL ⏱</button>
      <button class="btn-ghost menu-settings" data-act="settings">⚙ Nastavení</button>
      <div class="menu-foot">Miky Motorsport · v0.23</div>`;
    this.menu.querySelector('[data-act=career]').onclick = () => this.cb.onOpenCareer();
    this.menu.querySelector('[data-act=garage]').onclick = () => this.cb.onOpenGarage();
    this.menu.querySelector('[data-act=tt]').onclick = () => this.cb.onOpenTimeTrial();
    this.menu.querySelector('[data-act=settings]').onclick = () => this.cb.onOpenSettings();
    this.root.appendChild(this.menu);

    this.timetrial = div('screen career-screen');
    this.timetrial.innerHTML = `
      <div class="gar-top"><button class="btn-ghost gar-back" data-act="ttback">&lsaquo; Menu</button></div>
      <div class="career-title">TIME TRIAL ⏱</div>
      <div class="career-body" id="tt-body"></div>`;
    this.timetrial.querySelector('[data-act=ttback]').onclick = () => this.cb.onBackToMenu();
    this.root.appendChild(this.timetrial);

    this.settings = div('screen settings-screen');
    this.settings.innerHTML = `
      <div class="gar-top">
        <button class="btn-ghost gar-back" data-act="sback">&lsaquo; Menu</button>
      </div>
      <div class="career-title">NASTAVENÍ</div>
      <div class="settings-body" id="settings-body"></div>`;
    this.settings.querySelector('[data-act=sback]').onclick = () => this.cb.onBackToMenu();
    this.root.appendChild(this.settings);

    this.career = div('screen career-screen');
    this.career.innerHTML = `
      <div class="gar-top">
        <button class="btn-ghost gar-back" data-act="cback">&lsaquo; Menu</button>
        <div class="car-medals" id="car-medals"></div>
      </div>
      <div class="career-title">KARIÉRA</div>
      <div class="career-continue" id="career-continue"></div>
      <div class="career-body" id="career-body"></div>`;
    this.career.querySelector('[data-act=cback]').onclick = () => this.cb.onBackToMenu();
    this.root.appendChild(this.career);

    this.garage = div('screen garage-screen');
    this.garage.innerHTML = `
      <div class="gar-top">
        <div class="gar-topleft">
          <button class="btn-ghost gar-back" data-act="back">&lsaquo; Menu</button>
          <button class="btn-ghost" data-act="photo">📷 Foto</button>
        </div>
        <div class="gar-wallet">
          <img class="gar-miky" src="./img/miky-avatar.jpg" alt="Miky" draggable="false">
          <span class="gar-cr" id="gar-cr">0</span> CR
          <span class="gar-rank" id="gar-rank">Ucen Lv.1</span></div>
      </div>
      <div class="gar-left">
        <div class="gar-carname" id="gar-name">-</div>
        <div class="gar-pi"><span class="pi-class" id="gar-class">D</span>
          <span class="pi-val" id="gar-pival">0</span><small>PI</small></div>
        <div class="gar-stats" id="gar-stats"></div>
        <div class="gar-paintlabel">Lak</div>
        <div class="gar-paint" id="gar-paint"></div>
      </div>
      <div class="gar-right">
        <div class="gar-upg-title">Vylepšení</div>
        <div class="gar-upgrades" id="gar-upgrades"></div>
        <div class="gar-nextgoal" id="gar-nextgoal"></div>
        <button class="btn btn-primary gar-race" data-act="race">ZÁVOD! 🏁</button>
      </div>
      <div class="gar-cars" id="gar-cars"></div>`;
    this.garage.querySelector('[data-act=back]').onclick = () => this.cb.onBackToMenu();
    this.garage.querySelector('[data-act=race]').onclick = () => this.cb.onRace();
    this.garage.querySelector('[data-act=photo]').onclick = () => this.cb.onOpenPhoto();
    this.root.appendChild(this.garage);

    // Foto mod overlay (jen spodni lista - zbytek propousti drag na canvas)
    this.photo = div('screen photo-screen');
    this.photo.innerHTML = `
      <div class="photo-bar">
        <span class="photo-hint">Táhni myší = otáčení &middot; kolečko = zoom</span>
        <button class="btn btn-primary" data-act="cap">📷 Vyfotit</button>
        <button class="btn-ghost" data-act="pclose">Zavřít</button>
      </div>`;
    this.photo.querySelector('[data-act=cap]').onclick = () => this.cb.onPhotoCapture();
    this.photo.querySelector('[data-act=pclose]').onclick = () => this.cb.onPhotoClose();
    this.root.appendChild(this.photo);

    this.hideAll();
  }

  showPhoto() { this.hideAll(); this.photo.classList.remove('hidden'); }

  showMenu(profile) { this.hideAll(); this.menu.classList.remove('hidden'); if (profile) this.updateMenuCollection(profile); }

  // Globalni "zlata sbirka" na menu - dlouhodoby cil (kariera + time-attack + sampionaty).
  updateMenuCollection(profile) {
    const el = this.menu.querySelector('#menu-collection');
    if (!el) return;
    const tm = timeMedalTally(profile.timeTrials || {}, TRACK_ORDER, refLapOf, 3);
    const c = goldCollection(profile, tm.gold, tm.tracks);
    el.innerHTML = `🥇 Zlatá sbírka: <b>${c.gold}</b> / ${c.total}`
      + ` <span class="menu-collection-sub">(kariéra ${c.careerGold}/${c.careerTotal} · time ${c.timeGold}/${c.timeTotal} · tituly ${c.champTitles}/${c.champTotal})</span>`;
  }
  showGarage(profile, spec) { this.hideAll(); this.garage.classList.remove('hidden'); this.updateGarage(profile, spec); }
  showCareer(profile, playerPI) { this.hideAll(); this.career.classList.remove('hidden'); this.updateCareer(profile, playerPI); }
  showSettings(profile) { this.hideAll(); this.settings.classList.remove('hidden'); this.updateSettings(profile); }
  showTimeTrial(profile) { this.hideAll(); this.timetrial.classList.remove('hidden'); this.updateTimeTrial(profile); }
  hideAll() { this.menu.classList.add('hidden'); this.garage.classList.add('hidden'); this.career.classList.add('hidden'); this.settings.classList.add('hidden'); this.timetrial.classList.add('hidden'); this.photo.classList.add('hidden'); }

  // B3: mini-graf historie casu (vyssi sloupec = rychlejsi cas; nejlepsi zvyrazneny).
  _sparkline(history) {
    if (!Array.isArray(history) || history.length < 2) return '';
    const min = Math.min(...history), max = Math.max(...history);
    const range = max - min || 1;
    const bars = history.map((v) => {
      const h = Math.round(20 + (1 - (v - min) / range) * 80); // 20..100 % (rychlejsi = vyssi)
      return `<span class="spark-bar${v === min ? ' best' : ''}" style="height:${h}%"></span>`;
    }).join('');
    return `<div class="tt-spark" title="Historie časů (vyšší = rychlejší, zelený = PB)">${bars}</div>`;
  }

  updateTimeTrial(profile) {
    const fmt = fmtMs;
    const TT_LAPS = 3;
    const body = this.timetrial.querySelector('#tt-body');

    // --- Denni vyzva (J): deterministicka trat+rival ze dne, honis rivaluv ghost ---
    const day = dateKey(new Date());
    const ch = dailyChallenge(day, TRACK_ORDER, refLapOf,
      (id) => bestLapMsForTrack(profile.timeTrials, id));
    let dailyCard = '';
    if (ch) {
      const d = profile.daily && profile.daily.date === day ? profile.daily : null;
      const pb = d?.bestMs ?? null;
      const won = !!d?.wonToday;
      // Efektivni streak: ziva serie jen kdyz posledni vyhra byla dnes/vcera, jinak 0
      // (po prohre nebo novem dni nesmime ukazovat starou hodnotu - F-103).
      const streak = effectiveStreak(profile.daily, day);
      const trackName = TRACKS[ch.trackId]?.name || ch.trackId;
      const cilLabel = ch.personal ? 'tvé tempo' : 'rivala';
      const pbLine = pb != null
        ? `Tvůj čas: ${fmt(pb)} ${won ? '<span class="daily-won">✓ poražen</span>' : `<span class="daily-lost">cíl ${fmt(ch.targetMs)}</span>`}`
        : `Cíl (${cilLabel}): ${fmt(ch.targetMs)}`;
      dailyCard = `<div class="daily-card">
        <div class="daily-head"><span class="daily-badge">🗓 DENNÍ VÝZVA</span>
          ${streak > 0 ? `<span class="daily-streak">🔥 série ${streak}</span>` : ''}</div>
        <div class="daily-info">
          <div class="daily-name">${trackName} &middot; ${ch.laps} kol &middot; ⚔️ ${ch.rival}</div>
          <div class="daily-meta">${pbLine}</div>
        </div>
        <button class="btn btn-primary daily-go" data-daily="1">${pb != null ? 'ZNOVU' : 'JET'} 🗓</button>
      </div>`;
    }

    // --- Casove medaile: tally + per-trat cile ---
    const tally = timeMedalTally(profile.timeTrials || {}, TRACK_ORDER, refLapOf, TT_LAPS);
    const tallyLine = `<div class="tt-tally">Časové medaile: 🥇 ${tally.gold} &nbsp; 🥈 ${tally.silver} &nbsp; 🥉 ${tally.bronze}
      &nbsp;<span class="car-pi">(${tally.total}/${tally.tracks})</span></div>`;

    const rows = TRACK_ORDER.map((id) => {
      const t = TRACKS[id];
      const pb = profile.timeTrials?.[`${id}_${TT_LAPS}`];
      const refLap = refLapOf(id);
      const T = targetTimes(refLap, TT_LAPS);
      const medal = pb ? timeMedalFor(pb.totalMs, refLap, TT_LAPS) : null;
      const pbStr = pb ? `PB ${fmt(pb.totalMs)}${pb.bestLapMs ? ` &middot; nej. kolo ${fmt(pb.bestLapMs)}` : ''}` : 'zatím bez času';
      const targetsStr = `🥇 ${fmt(T.gold)} &nbsp; 🥈 ${fmt(T.silver)} &nbsp; 🥉 ${fmt(T.bronze)}`;
      return `<div class="event-row">
        <div class="event-info">
          <div class="event-name">${medalPrefix(medal)}${t.name}</div>
          <div class="event-meta">${pbStr}</div>
          <div class="tt-targets">${targetsStr}</div>
        </div>
        ${this._sparkline(pb && pb.history)}
        <button class="btn-buy event-go" data-tt="${id}">JET ⏱</button>
      </div>`;
    }).join('');

    body.innerHTML = dailyCard
      + `<div class="settings-note">Sólo jízda na čas (3 kola) proti vlastnímu ghostovi. Poraž cílové časy a sbírej časové medaile!</div>`
      + tallyLine + rows;

    const db = body.querySelector('[data-daily]');
    if (db) db.onclick = () => this.cb.onStartDaily();
    body.querySelectorAll('[data-tt]').forEach((b) => { b.onclick = () => this.cb.onStartTimeTrial(b.dataset.tt); });
  }

  updateSettings(profile) {
    const s = profile.settings;
    const rows = [
      { key: 'abs', group: 'assists', label: 'ABS', desc: 'Zabraňuje zablokování kol při brzdění', on: s.assists.abs },
      { key: 'tcs', group: 'assists', label: 'Kontrola trakce (TCS)', desc: 'Omezuje protáčení při plynu', on: s.assists.tcs },
      { key: 'stability', group: 'assists', label: 'Stabilizace', desc: 'Tlumí přetáčivost (smyk zádi)', on: s.assists.stability },
      { key: 'idealLine', group: 'root', label: 'Ideální stopa', desc: 'Zobrazí svítící stopu na trati', on: s.idealLine },
      { key: 'actionCam', group: 'root', label: 'Akční kamera', desc: 'Náklon a vedení kamery do zatáčky (jemné; výchozí vypnuto)', on: s.actionCam },
    ];
    const off = assistsOffCount(s.assists);
    const bonus = off * 8;
    const body = this.settings.querySelector('#settings-body');
    body.innerHTML = `
      <div class="settings-note">Asistenti jsou zapnutí pro pohodlnou jízdu. Vypnutí = větší
        výzva i <b>+${bonus}% odměna</b> (${off}/3 vypnuto).</div>
      ${rows.map((r) => `
        <div class="event-row">
          <div class="event-info">
            <div class="event-name">${r.label}</div>
            <div class="event-meta">${r.desc}</div>
          </div>
          <button class="toggle${r.on ? ' on' : ''}" data-key="${r.key}" data-group="${r.group}">
            ${r.on ? 'ZAP' : 'VYP'}</button>
        </div>`).join('')}`;
    body.querySelectorAll('[data-key]').forEach((b) => {
      b.onclick = () => this.cb.onToggleSetting(b.dataset.group, b.dataset.key);
    });
  }

  updateCareer(profile, playerPI) {
    const view = careerView(profile, playerPI);
    const tally = medalTally(profile);
    this.career.querySelector('#car-medals').innerHTML =
      `🥇 ${tally.gold} &nbsp; 🥈 ${tally.silver} &nbsp; 🥉 ${tally.bronze} &nbsp;
       <span class="car-pi">PI ${playerPI} (${piClass(playerPI)})</span>`;

    // "Pokracovat" - prvni odemceny event bez zlata
    const nextId = nextRecommendedEvent(profile, playerPI);
    const cont = this.career.querySelector('#career-continue');
    if (nextId) {
      const f = findEvent(nextId);
      cont.innerHTML = `<button class="btn btn-primary" data-cont="${nextId}">▶ POKRAČOVAT: ${f.event.name}</button>`;
      const b = cont.querySelector('[data-cont]');
      if (b) b.onclick = () => this.cb.onStartEvent(nextId);
      cont.style.display = '';
    } else {
      cont.innerHTML = '';
      cont.style.display = 'none';
    }

    const body = this.career.querySelector('#career-body');
    // Medailova pyramida pro event - zlato/stribro/bronz jako CILE (rozsvicene = ziskane).
    const medalPyramid = (bestPos) => {
      const m = medalSlots(bestPos);
      return `<span class="medal-slots" title="Cíle: 🥇 1. místo · 🥈 2. · 🥉 3.">`
        + `<span class="ms${m.gold ? ' on' : ''}">🥇</span>`
        + `<span class="ms${m.silver ? ' on' : ''}">🥈</span>`
        + `<span class="ms${m.bronze ? ' on' : ''}">🥉</span></span>`;
    };
    body.innerHTML = view.map((sv) => {
      const s = sv.series;
      const locked = !sv.unlocked;
      const golds = sv.events.filter((e) => e.medal === 'gold').length;
      const head = `<div class="series-head">
          <span class="series-klass" data-cls="${s.klass}">${s.klass}</span>
          <span class="series-name">${s.name}${s.championship ? ' <span class="series-champ">🏆 ŠAMPIONÁT</span>' : ''}</span>
          <span class="series-prog" title="Získaná zlata / celkem eventů">🥇 ${golds}/${sv.total}${sv.medals > golds ? ` <span class="series-prog-any">(${sv.medals}/${sv.total} 🏅)</span>` : ''}</span>
          ${locked ? `<span class="series-lock">🔒 Dohraj předchozí</span>`
            : (s.minPI && playerPI < s.minPI ? `<span class="series-hint">doporučené PI ${s.minPI}</span>` : '')}
        </div>
        <div class="series-desc">${s.desc}</div>`;
      const evs = sv.events.map((ev) => {
        const e = ev.event;
        const d = DIFFICULTY[e.difficulty];
        const evLocked = locked || !ev.unlocked;
        const modeLabel = { circuit: 'Závod', sprint: 'Sprint', duel: 'Duel 1v1', elimination: 'Eliminace', pursuit: 'Stíhačka' }[e.mode || 'circuit'];
        const lapsTxt = e.mode === 'elimination' ? `${e.laps} kol · vyřazovací` : `${e.laps} ${e.laps === 1 ? 'kolo' : 'kol'}`;
        const meta = `${modeLabel} &middot; ${lapsTxt} &middot; ${d.label}${e.rival ? ` &middot; ⚔️ ${e.rival}` : ''}`;
        return `<div class="event-row${evLocked ? ' locked' : ''}">
          <div class="event-info">
            <div class="event-name">${e.name}${e.finale ? ' ⭐' : ''}</div>
            <div class="event-meta">${meta}</div>
            ${medalPyramid(ev.bestPos)}
          </div>
          <button class="btn-buy event-go" data-ev="${e.id}" ${evLocked ? 'disabled' : ''}>
            ${evLocked ? (locked ? 'ZAMČENO' : 'NEJDŘÍV PŘEDCHOZÍ') : (ev.done ? 'ZNOVU' : 'ZÁVOD')}</button>
        </div>`;
      }).join('');
      // Sampionat: prubezne poradi (body napric serii). Jen u odemcenych serii.
      let champBlock = '';
      if (s.championship && !locked) {
        const { done, total } = championshipProgress(profile, s);
        const rows = championshipStandings(profile, s);
        const rowsHtml = rows.length
          ? rows.map((r, i) => `<li class="champ-row${r.isPlayer ? ' me' : ''}">
              <span class="champ-pos">${i + 1}.</span>
              <span class="champ-name">${escapeHtml(r.name)}${r.isPlayer ? ' (ty)' : ''}</span>
              <span class="champ-pts">${r.points} b</span></li>`).join('')
          : '<li class="champ-empty">Body se sčítají napříč celou sérií - odjeď první event!</li>';
        champBlock = `<div class="champ-standings">
            <div class="champ-title">🏆 Průběžné pořadí (${done}/${total} odjeto)</div>
            <ol class="champ-rows">${rowsHtml}</ol>
          </div>`;
      }
      return `<div class="series-card${locked ? ' locked' : ''}${s.championship ? ' championship' : ''}">${head}<div class="series-events">${evs}</div>${champBlock}</div>`;
    }).join('');

    body.querySelectorAll('[data-ev]').forEach((b) => {
      if (b.disabled) return;
      b.onclick = () => this.cb.onStartEvent(b.dataset.ev);
    });
  }

  updateGarage(profile, spec, viewId = null) {
    const isPreview = !!viewId && viewId !== profile.currentCar;
    this._renderCarSelector(profile, isPreview ? viewId : null);
    if (isPreview) { this._renderGaragePreview(profile, viewId); return; }
    // obnov viditelnost laku + ZAVOD tlacitka (po navratu z nahledu)
    const plLbl = this.garage.querySelector('.gar-paintlabel'); if (plLbl) plLbl.style.display = '';
    const raceBtn0 = this.garage.querySelector('[data-act=race]'); if (raceBtn0) raceBtn0.style.display = '';
    const ng0 = this.garage.querySelector('#gar-nextgoal'); if (ng0) ng0.onclick = null;
    const car = profile.cars[profile.currentCar];
    const upg = car.upgrades;
    const pi = computePI(spec, upg);
    const cls = piClass(pi);
    const lv = levelFromXp(profile.xp);

    this.garage.querySelector('#gar-cr').textContent = profile.credits.toLocaleString('cs-CZ');
    this.garage.querySelector('#gar-rank').textContent = `${rankName(lv.level)} Lv.${lv.level}`;
    this.garage.querySelector('#gar-name').textContent = spec.name;
    this.garage.querySelector('#gar-pival').textContent = pi;
    const clsEl = this.garage.querySelector('#gar-class');
    clsEl.textContent = cls;
    clsEl.dataset.cls = cls;

    // staty
    const st = carStats(spec, upg);
    const labels = { power: 'Výkon', grip: 'Grip', brakes: 'Brzdy', weight: 'Odlehčení' };
    this.garage.querySelector('#gar-stats').innerHTML = Object.keys(labels).map((k) =>
      `<div class="stat-row"><span class="stat-lbl">${labels[k]}</span>
        <span class="stat-bar"><span class="stat-fill" style="width:${Math.round(st[k] * 100)}%"></span></span></div>`
    ).join('');

    // lak
    this.garage.querySelector('#gar-paint').innerHTML = PAINTS.map((c) =>
      `<button class="paint-swatch${c === car.paint.color ? ' sel' : ''}" data-color="${c}" style="background:${hex(c)}"></button>`
    ).join('');
    this.garage.querySelectorAll('.paint-swatch').forEach((b) => {
      b.onclick = () => this.cb.onPaint(parseInt(b.dataset.color, 10));
    });

    // upgrady
    this.garage.querySelector('#gar-upgrades').innerHTML = UPGRADES.map((u) => {
      const lvl = upg[u.id] || 0;
      const cost = upgradeCost(u.id, lvl);
      const maxed = lvl >= u.max;
      const afford = cost != null && profile.credits >= cost;
      const dots = Array.from({ length: u.max }, (_, i) => `<span class="dot${i < lvl ? ' on' : ''}"></span>`).join('');
      return `<div class="upg-row">
        <div class="upg-info"><div class="upg-name">${u.name}</div>
          <div class="upg-desc">${u.desc}</div><div class="upg-dots">${dots}</div></div>
        <button class="btn-buy${maxed ? ' maxed' : afford ? '' : ' poor'}" data-buy="${u.id}" ${maxed || !afford ? 'disabled' : ''}>
          ${maxed ? 'MAX' : cost.toLocaleString('cs-CZ') + ' CR'}</button>
      </div>`;
    }).join('');
    this.garage.querySelectorAll('[data-buy]').forEach((b) => {
      if (b.disabled) return;
      b.onclick = () => this.cb.onBuyUpgrade(b.dataset.buy);
    });

    // next goal - nejlevnejsi dostupny upgrade
    const ng = this.garage.querySelector('#gar-nextgoal');
    let cheapest = null;
    for (const u of UPGRADES) {
      const lvl = upg[u.id] || 0;
      const c = upgradeCost(u.id, lvl);
      if (c != null && (cheapest == null || c < cheapest.cost)) cheapest = { name: u.name, cost: c };
    }
    if (!cheapest) {
      ng.innerHTML = `Auto plně vylepšené! 🔧 PI ${pi} (${cls})`;
    } else if (profile.credits >= cheapest.cost) {
      ng.innerHTML = `Můžeš koupit <b>${cheapest.name}</b> za ${cheapest.cost.toLocaleString('cs-CZ')} CR`;
    } else {
      const need = cheapest.cost - profile.credits;
      // typicka vyhra ~2800 CR (vyhra rookie/clubsport eventu); driv 1100 = 2-5x pesimisticke
      const races = Math.max(1, Math.ceil(need / 2800));
      ng.innerHTML = `Do <b>${cheapest.name}</b> chybí ${need.toLocaleString('cs-CZ')} CR (~${races} závodů)`;
    }
  }

  // Nahled jineho auta (vc. zamcenych) - header/staty + akce koupit/vybrat. Lak+ZAVOD skryty.
  _renderGaragePreview(profile, id) {
    const base = getCar(id);
    const car = profile.cars[id];
    const owned = !!(car && car.owned);
    const upg = owned ? car.upgrades : {};
    const pi = computePI(base, upg);
    const cls = piClass(pi);
    this.garage.querySelector('#gar-name').textContent = owned ? base.name : `🔒 ${base.name}`;
    this.garage.querySelector('#gar-pival').textContent = pi;
    const clsEl = this.garage.querySelector('#gar-class');
    clsEl.textContent = cls; clsEl.dataset.cls = cls;
    const st = carStats(base, upg);
    const labels = { power: 'Výkon', grip: 'Grip', brakes: 'Brzdy', weight: 'Odlehčení' };
    this.garage.querySelector('#gar-stats').innerHTML = Object.keys(labels).map((k) =>
      `<div class="stat-row"><span class="stat-lbl">${labels[k]}</span>
        <span class="stat-bar"><span class="stat-fill" style="width:${Math.round(st[k] * 100)}%"></span></span></div>`
    ).join('');
    // lak + ZAVOD skryt (patri aktualnimu autu)
    this.garage.querySelector('#gar-paint').innerHTML = '';
    const pl = this.garage.querySelector('.gar-paintlabel'); if (pl) pl.style.display = 'none';
    const rb = this.garage.querySelector('[data-act=race]'); if (rb) rb.style.display = 'none';
    // upgrady jen pro cteni (kolik stupnu auto ma)
    this.garage.querySelector('#gar-upgrades').innerHTML = UPGRADES.map((u) => {
      const lvl = upg[u.id] || 0;
      const dots = Array.from({ length: u.max }, (_, i) => `<span class="dot${i < lvl ? ' on' : ''}"></span>`).join('');
      return `<div class="upg-row preview"><div class="upg-info"><div class="upg-name">${u.name}</div>
        <div class="upg-dots">${dots}</div></div></div>`;
    }).join('');
    // akce: vlastnene -> vybrat; zamcene -> koupit / chybi CR
    const ng = this.garage.querySelector('#gar-nextgoal');
    ng.onclick = null;
    if (owned) {
      ng.innerHTML = `<button class="btn btn-primary gar-race" data-selprev="${id}">VYBRAT TOTO AUTO</button>`;
      ng.querySelector('[data-selprev]').onclick = () => this.cb.onSelectCar(id);
    } else if (profile.credits >= base.price) {
      ng.innerHTML = `<button class="btn btn-primary gar-race" data-buyprev="${id}">KOUPIT za ${base.price.toLocaleString('cs-CZ')} CR</button>`;
      ng.querySelector('[data-buyprev]').onclick = () => this.cb.onBuyCar(id);
    } else {
      const need = base.price - profile.credits;
      const races = Math.max(1, Math.ceil(need / 2800));
      ng.innerHTML = `🔒 Cena ${base.price.toLocaleString('cs-CZ')} CR &middot; chybí <b>${need.toLocaleString('cs-CZ')} CR</b> (~${races} závodů)`;
    }
  }

  // Vyber/koupe/nahled auta (strip dole). viewId = prave nahlizene auto (zvyrazni se).
  _renderCarSelector(profile, viewId = null) {
    const el = this.garage.querySelector('#gar-cars');
    el.innerHTML = CAR_ORDER.map((id) => {
      const base = getCar(id);
      const owned = profile.cars[id] && profile.cars[id].owned;
      const current = id === profile.currentCar;
      const viewing = id === viewId;
      const afford = profile.credits >= base.price;
      let action;
      if (current) action = '<div class="cc-cur">✓ AKTUÁLNÍ</div>';
      else if (owned) action = `<button class="cc-btn" data-selcar="${id}">Vybrat</button>`;
      else action = `<button class="cc-btn buy${afford ? '' : ' poor'}" data-buycar="${id}"${afford ? '' : ' disabled'}>${base.price.toLocaleString('cs-CZ')} CR</button>`;
      return `<div class="car-chip${current ? ' cur' : ''}${owned ? '' : ' locked'}${viewing ? ' viewing' : ''}" data-preview="${id}" title="Klikni pro náhled">
        <div class="cc-top"><span class="pi-class" data-cls="${base.cls}">${base.cls}</span>
          <span class="cc-name">${base.name}</span></div>
        <div class="cc-meta">PI ${base.basePI} &middot; ${base.drive}</div>
        ${action}</div>`;
    }).join('');
    // klik na chip = nahled (3D model + staty); tlacitka uvnitr stopnou bublani
    el.querySelectorAll('.car-chip').forEach((c) => { c.onclick = () => this.cb.onPreviewCar(c.dataset.preview); });
    el.querySelectorAll('[data-selcar]').forEach((b) => { b.onclick = (e) => { e.stopPropagation(); this.cb.onSelectCar(b.dataset.selcar); }; });
    el.querySelectorAll('[data-buycar]').forEach((b) => { if (!b.disabled) b.onclick = (e) => { e.stopPropagation(); this.cb.onBuyCar(b.dataset.buycar); }; });
  }
}
